<template>
  <section>
    <p>Pausas</p>
    <activity-overview :type="type" :moduleType="moduleType" />
  </section>
</template>

<script>
/**
 * @author Abraham Correa
 */
import ActivityOverview from "@/components/Agents/ActivityOverview";
export default {
  components: {
    ActivityOverview,
  },
  data() {
    return {
      type: "pauses",
      moduleType: "agentsPauses"
    };
  },
};
</script>

<style>
</style>